import {
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Tooltip,
} from "..";
import { formatPrice } from "../../utils";

const TabelaCustoDialog = ({
  openDialog,
  setOpenDialog,
  produtos,
  totais
}) => {

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 200,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 700,
    },
    {
      field: "quantidade",
      headerName: "Quantidade",
      flex: 350,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => Number.isInteger(parseFloat(params.value)) 
        ? params.value
        : params.value.toFixed(3).replace(".", ",")
    },
    {
      field: "precoCusto",
      headerName: "Preço Custo (R$)",
      flex: 350,
      headerAlign: 'right',
      align: 'right',
      valueGetter: (params) => 
        params.value ? formatPrice(parseFloat(params.value), false) : "",
    },
    {
      field: "total",
      headerName: "Total (R$)",
      flex: 350,
      headerAlign: 'right',
      align: 'right',
    },
    {
      field: "dif",
      headerName: "Diferença (%)",
      flex: 350,
      headerAlign: 'right',
      align: 'right',
    },
  ];

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  return (
    <Dialog fullWidth maxWidth={"lg"} open={openDialog} onClose={handleCloseDialog}>
      <CardHeader title="Tabela de Custos dos Produtos" className="ms-2 mt-2" />
      <DialogContent>
        <DataGrid
          rows={produtos}
          columns={colunas}
          rowCount={produtos.length}
          disableAcoes
        />
      </DialogContent>
      <DialogActions 
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          mx: 2,
        }}
      >
        <Button
          onClick={handleCloseDialog}
          color="primary"
          variant="contained"
        >
          Fechar
        </Button>
        <Box sx={{ textAlign: 'right', border: '1px solid #ccc', p: 1.5, borderRadius: 1 }}>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body1" sx={{ mr: 13 }}>Total de Venda (R$)</Typography>
            <Typography variant="body1">{formatPrice(totais.totalVenda, false)}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography variant="body1" sx={{ mr: 13 }}>Total de Custo (R$)</Typography>
            <Typography variant="body1">{formatPrice(totais.totalCusto, false)}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" gap={0.5}>
              <Typography variant="body1">Diferença (R$)</Typography>
              <Tooltip
                arrow
                placement="bottom"
                title={
                  <div className="modelo-div-title" style={{ fontSize: '12px' }}>
                    {`Percentual entre venda e custo: ${totais.percentualDif}%`}
                  </div>
                }
              >
                <i className="ph-fill ph-info" style={{ fontSize: 20, position: 'relative', top: '1px' }}></i>
              </Tooltip>
            </Box>
            <Typography variant="body1">{totais.totalDif}</Typography>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default TabelaCustoDialog;
